import React from 'react';
import ActionButton from 'components/ActionButton';

export default function EditButton({ contractId, onEditClick }: {
  contractId: number, onEditClick: () => void
}) {
  return (
    <ActionButton
      icon="edit"
      onClick={onEditClick}
      tooltipText="Editar empresa"
      id={`edit-company-${contractId}`}
    />
  );
}
